import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStudentMe } from '../../modules/roster/hooks/useStudentMe';
import { useTutorTenantLabels } from '../../modules/tutor/hooks/useTutorTenantLabels';
import { useLearnerCurriculum } from '../../modules/curriculum/hooks/useLearnerCurriculum';
import { isEffectiveMalayLearner } from '../../modules/curriculum/learnerCurriculumOverride';
import { ROUTES } from '../../utils/constants';
import { Spinner } from '../ui/Spinner';

interface ReadingComprehensionAccessGateProps {
  children: React.ReactNode;
}

/** Malay curriculum learner + Grade 7 only. Legacy tenant routing; explicit Tamil denied. */
export function ReadingComprehensionAccessGate({ children }: ReadingComprehensionAccessGateProps) {
  const { labels, loading: labelsLoading, schoolLanguage } = useTutorTenantLabels();
  const { curriculum } = useLearnerCurriculum();
  const { grade, isRosterLoading } = useStudentMe();

  const waitingForTenant = labelsLoading && !schoolLanguage;
  const waitingForGrade = isRosterLoading && grade == null;

  if (waitingForTenant || waitingForGrade) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (
    !isEffectiveMalayLearner({
      curriculum,
      legacyTenantIsMalay: labels.isMalay,
    })
  ) {
    return <Navigate to={ROUTES.STUDENT_DASHBOARD} replace />;
  }

  const gradeNum = typeof grade === 'number' ? grade : parseInt(String(grade ?? ''), 10);
  if (!Number.isFinite(gradeNum) || gradeNum !== 7) {
    return <Navigate to={ROUTES.STUDENT_DASHBOARD} replace />;
  }

  return <>{children}</>;
}
